import React from 'react';
import Portal from '@spothero/ui/portal';
import SHLoader from 'common/loader/SHLoader';

const RouterLoader = props => {
    return (
        <Portal className="RouterLoader">
            <SHLoader />
        </Portal>
    );
};

export default RouterLoader;
